<template>
  <div class="text-center lead" style="padding-top: 15%">
    403 Forbidden<br />
    You don't have the permission to access this page.<br />
    <p>Please contact BOLT administrators for any questions.</p>
    <button class="btn btn-primary btn-sm mb-3" @click.prevent="$router.go(-2)">
      Back to previous page
    </button>
  </div>
</template>

<script>
export default {
  name: "Error403View",
};
</script>
